import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferralNotPaid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 15,
			height: 15,
			rx: 7.5,
			stroke: "#85A0AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.94865 4.94904L10.9492 10.9488",
			stroke: "#85A0AD",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9496 4.94904L4.94986 10.9496",
			stroke: "#85A0AD",
			strokeWidth: 1.5
		})
	]
});
export default SvgReferralNotPaid;
